import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.5rem;

  & > header {
    margin-bottom: 2rem;

    & h1 {
      margin-bottom: 1rem;
    }
    & > .subtitle {
      font-size: 1rem;
      font-family: ${({ theme }) => theme.fonts.workSans};
      color: ${({ theme }) => theme.colors.grayDark4};
    }
  }
`;

export const InputsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  max-width: 58.75rem;
  gap: 1rem;
  margin-bottom: 0.5rem;

  & > div {
    &.customer-select {
      flex-grow: 1;
    }
    &.date-field {
      width: 18rem;
    }
  }

  & > button {
    width: 10rem;
  }
`;
